const SignInTypes = {
    SIGN_IN_START: 'SIGN_IN_START',
    SIGN_IN_SUCCESS: 'SIGN_IN_SUCCESS',
    SIGN_IN_FAILURE: 'SIGN_IN_FAILURE',
    LOGOUT_SESSION: "LOGOUT_SESSION",
}

export default SignInTypes;